"use client";

import { cn } from "@repo/ui/lib/utils";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";

const TVFilter = () => {
  return (
    <div
      className="absolute right-0 inset-0"
      style={{
        backgroundImage: "url(/image/4x1_black.png)",
      }}
    />
  );
};

export const MyActivity: React.FC = () => {
  const [activeSection, setActiveSection] = useState<number>(0);
  const [isAutoScrollActive, setIsAutoScrollActive] = useState<boolean>(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      isAutoScrollActive && setActiveSection((prev) => (prev + 1) % 3);
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isAutoScrollActive]);

  return (
    <div
      id="activity"
      className="grid desktop:grid-cols-3 desktop:grid-rows-2 grid-cols-1 grid-rows-3 border-brand border-t-[2px] -mx-header-gap"
    >
      <div
        role="none"
        className="relative row-span-1 desktop:col-span-2 border-brand desktop:border-r-[2px] border-b-[2px] desktop:border-b-0 desktop:row-span-2"
        onMouseEnter={() => {
          setActiveSection(0);
          setIsAutoScrollActive(false);
        }}
        onMouseLeave={() => setIsAutoScrollActive(true)}
      >
        <TVFilter />
        <ReactPlayer
          width="100%"
          height="100%"
          loop={true}
          muted
          playing={true}
          src="https://www.youtube.com/watch?v=NuJrQwjpHPs"
        />

        <div
          className={cn(
            "absolute inset-0 flex flex-col justify-center items-center space-y-2 transition-all duration-500 group",
            {
              "is-active backdrop-brightness-50": activeSection === 0,
              "backdrop-brightness-100": activeSection !== 0,
            },
          )}
        >
          <div className="text-3xl laptop:text-5xl desktop:text-6xl font-bold text-primary opacity-0 group-[.is-active]:opacity-100 transition-all duration-500">
            {"CODING // TEACHING"}
          </div>
          <div className="text-md laptop:text-lg desktop:text-xl text-center max-w-[70%] opacity-0 group-[.is-active]:opacity-100 transition-all duration-500 hidden tablet:block">
            Software engineer by trade, I have always taken pride in building tools and solutions for real life
            challenges. Professionally I build softwares for the energy sector. In my free time, I spend time in my man
            cave, working on hobby projects and exploring the next cool technology. I have worked in different domains
            and with different technologies. As of now I am more of a full stack data engineer, which basically
            translates to me working on React, NodeJS, MongoDB and Kafka. Although I am also proficient in C++, Python
            and have built many cool things with them.
          </div>
        </div>
      </div>
      <div
        role="none"
        className="relative bg-green border-brand border-b-[2px] aspect-video"
        onMouseEnter={() => {
          setActiveSection(1);
          setIsAutoScrollActive(false);
        }}
        onMouseLeave={() => setIsAutoScrollActive(true)}
      >
        <TVFilter />
        <ReactPlayer
          width="100%"
          height="100%"
          loop={true}
          muted
          playing={true}
          src="https://www.youtube.com/watch?v=ycl-E0A6wQE&t=2748s"
        />

        <div
          className={cn(
            "absolute inset-0 flex flex-col justify-center items-center space-y-2 transition-all duration-500 group",
            {
              "is-active backdrop-brightness-50": activeSection === 1,
              "backdrop-brightness-100": activeSection !== 1,
            },
          )}
        >
          <div className="text-3xl font-bold text-primary opacity-0 group-[.is-active]:opacity-100 transition-all duration-500 desktop:text-lg">
            {"GAMING // CASTING"}
          </div>
          <div className="hidden tablet:block text-md text-center max-w-[70%] opacity-0 group-[.is-active]:opacity-100 transition-all duration-500 desktop:text-sm">
            An avid enjoyer of video games, RTS games in particular. I have spent a lot of time playing AOE4, COH2, Men
            of War, Iron Harvest just to name a few. Lately I have started streaming my own games and casting pro
            matches for the community. I have also started a small community of RTS players where we host tournaments
            and other casual events. Recently I have joined a gaming club in Volda where I am meeting new people and
            learning from some really talented players.
          </div>
        </div>
      </div>
      <div
        role="none"
        className="relative bg-blue aspect-video"
        onMouseEnter={() => {
          setActiveSection(2);
          setIsAutoScrollActive(false);
        }}
        onMouseLeave={() => setIsAutoScrollActive(true)}
      >
        <TVFilter />
        <ReactPlayer
          width="100%"
          height="100%"
          loop={true}
          muted
          playing={true}
          src="https://www.youtube.com/watch?v=pTRxLFg0v58"
        />

        <div
          className={cn(
            "absolute inset-0 flex flex-col justify-center items-center space-y-2 transition-all duration-500 group",
            {
              "is-active backdrop-brightness-50": activeSection === 2,
              "backdrop-brightness-100": activeSection !== 2,
            },
          )}
        >
          <div className="text-3xl font-bold text-primary opacity-0 group-[.is-active]:opacity-100 transition-all duration-500">
            {"ART // OUTDOORS"}
          </div>
          <div className="hidden tablet:block text-md text-center max-w-[70%] opacity-0 group-[.is-active]:opacity-100 transition-all duration-500">
            I draw and paint in my free time. I also play the Ukulele and sing mellow songs. I have recently picked up
            the Synthesizer. I have a few recording that you might want to checkout. I am also a big fan of the outdoor
            activities - running, hiking, trekking and camping. I generally take my camera with me to film some ASMR
            videos, or slow TV as we call it in Norway. I have also started a small YouTube channel where I post my
            videos.
          </div>
        </div>
      </div>
    </div>
  );
};
